
<div class="yield-est-main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="yield-est-pin-close-container">
        <div class="header-container-new-yield-est-pin">
            <span><img src="../../assets/icons/yield_estimations_pin.png" alt="New Pin Icon" class="new-yield-est-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-yield-est-pin-header">Yield Estimation</h1>
        </div>
    </div>

<div class="yield-est-pin-info-container">

    <div class="yield-est-pin-container">
        <div class="yield-est-pin-headers">
            <p class="yield-est-pin-header-text">Date and Time:</p>
            <p class="yield-est-pin-header-text">Latitude:</p>
            <p class="yield-est-pin-header-text">Longitude:</p>
            <p class="yield-est-pin-header-text">Farm:</p>
            <p class="yield-est-pin-header-text">Field:</p>
            <p class="yield-est-pin-header-text">Created By:</p>
        </div>

    </div>

    <div class="yield-est-pin-container">
        <ng-container>
            <p class="yield-est-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
            <p class="yield-est-pin-info-text">{{pinObj.lat}}</p>
            <p class="yield-est-pin-info-text">{{pinObj.lng}}</p>
            <p class="yield-est-pin-info-text">{{pinObj.farm}}</p>
            <p class="yield-est-pin-info-text">{{pinObj.field}}</p>
            <p class="yield-est-pin-info-text">{{pinObj.creatingUser}}</p>
        </ng-container>

    </div>
 </div>


    <mat-divider></mat-divider>

    <form [formGroup]="updatePinForm">
        <mat-form-field class="yield-est-pin-input" appearance="outline">
            <mat-label>Pin Name</mat-label>
            <input matInput formControlName="pinDescription">
            <!-- <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error> -->
        </mat-form-field>

        <!-- DROP DOWN -->
        <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Unit of Measure</mat-label>
            <mat-select formControlName="unitOfMeasure">
              <mat-option *ngFor="let unit of unitOfMeasureList" [value]="unit.id">
                {{unit.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        <mat-form-field class="yield-est-pin-input" appearance="outline">
            <mat-label>Yield Estimation</mat-label>
            <input matInput formControlName="yieldEstimation"  oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            <!-- <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error> -->
        </mat-form-field>

        <mat-form-field class="yield-est-pin-input" appearance="outline">
            <mat-label>Yield Weighted Value (%)</mat-label>
            <input matInput formControlName="yieldWeightedValue"  oninput="this.value = this.value.replace(/[^0-9.]/g, '');" maxlength="8">
            <!-- <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error> -->
        </mat-form-field>

          <!-- DATE -->

          <mat-form-field style="width: 100%;" appearance="outline" class="yield-est-pin-input">
            <mat-label>Estimation date</mat-label>
            <input matInput [matDatepicker]="datepicker" formControlName="estimationDate">
            <mat-datepicker-toggle matIconSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker>
              <mat-datepicker-actions>
                <button mat-button matDatepickerCancel>Cancel</button>
                <button mat-raised-button matDatepickerApply class="apply-date-text">Apply</button>
              </mat-datepicker-actions>
            </mat-datepicker>
          </mat-form-field>

    <div class="yield-est-pin-delete-btn-container">
        <button class="delete-yield-est-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
            <div class="yield-est-pin-btn-content">
                <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-yield-est-pin-btn-icon">
                <span><p class="yield-est-pin-btn-text">DELETE PIN</p></span>
            </div>
        </button>

        <button class="yield-est-pin-update-btn" mat-flat-button type="button" (click)=" updatePin()">
            <div class="yield-est-pin-btn-content">
                <p class="yield-est-pin-btn-text">UPDATE PIN</p> 
            </div>
        </button>
    </div>
</form>

</div>


